import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.PaymentsRestService
 *
 * @description
 * This class contains methods used to retrieve information about apps
 * using http requests.
 */
export default class PaymentsRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
     * @ngdoc function
     * @name rest.services.PaymentsRestService#create
     * @methodOf rest.services.PaymentsRestService
     * @function
     *
     * @description
     * Create an action
     *
     * @returns {Promise} The promise of the call.
     */
    create(payload) {

        return super.create(payload, 'payments/');

    }

}

_serviceDependencies.push(PaymentsRestService);

angular.module('rest.services')
    .service('PaymentsRestService', _serviceDependencies);




// WEBPACK FOOTER //
// ./scripts/restServices/paymentsRestService.js